<template>
    <div class="home">
      <HeaderComponent></HeaderComponent>
      <ProfileComponent></ProfileComponent>
      <div>
        <!-- <FooterComponent></FooterComponent> -->
      </div>
    </div>
  </template>

<script>
// @ is an alias to /src
import HeaderComponent from '@/components/header/header.vue'
import ProfileComponent from '@/components/profile/ProfileComponent.vue'
// import FooterComponent from '@/components/footer/footer.vue'

export default {
  name: 'ProfilePage',
  components: {
    HeaderComponent,
    ProfileComponent
    // FooterComponent
  }
}
</script>
